import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormField, MatLabel, MatError, MatHint, MatPrefix } from '@angular/material/form-field';
import { PartsListComponent } from './parts-list/parts-list.component';
import { AddCurrencyPrefixDirective } from '../../../shared/directives/add-currency-prefix.directive';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { NgIf, NgFor } from '@angular/common';
import { MatInput } from '@angular/material/input';

interface TemplateFormValue {
  name: string;
  type: string;
  details: string | null;
  notes: string | null;
  due_date_offset: string | null;
  labour_hours: number;
  labour_cost: number;
  parts: any[];
}

@Component({
    selector: 'app-template-form',
    templateUrl: './template-form.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { subscriptSizing: 'dynamic' }
        }
    ],
    standalone: true,
    imports: [ReactiveFormsModule, MatFormField, MatLabel, MatInput, NgIf, MatError, MatSelect, NgFor, MatOption, MatHint, CdkTextareaAutosize, MatPrefix, AddCurrencyPrefixDirective, PartsListComponent]
})
export class TemplateFormComponent {
  form = new FormGroup({
    name: new FormControl<string>('', Validators.required),
    type: new FormControl<string>('', Validators.required),
    details: new FormControl<string>(''),
    notes: new FormControl<string>(''),
    due_date_offset: new FormControl<string>(''),
    labour_hours: new FormControl<number>(null, Validators.required),
    labour_cost: new FormControl<number>(null, Validators.required),
    parts: new FormControl([])
  });
  jobTypes = ['Repair', 'Service', 'Calibration'];

  @Input() set value(value: TemplateFormValue) {
    if (value) {
      const labour_cost = value.labour_cost ? value.labour_cost / 100 : null;
      this.form.patchValue(value);
      this.form.patchValue({ labour_cost });
    }
  }
}
